import useTranslation from 'next-translate/useTranslation'

type ProductRatingProps = {
  type: string
  title: string
  low: string
  middle?: string
  high: string
}

export const additionalRatingOptions = (): ProductRatingProps[] => {
  const { t } = useTranslation('common')

  return [
    {
      type: 'Size',
      title: t('Category.Filter.size'),
      low: t('ProductDetail.RatingPopup.SizeRating.sizeRatingLow'),
      middle: t('ProductDetail.RatingPopup.SizeRating.sizeRatingMiddle'),
      high: t('ProductDetail.RatingPopup.SizeRating.sizeRatingHigh')
    },
    {
      type: 'Color',
      title: t('Category.Filter.color'),
      low: t('ProductDetail.RatingPopup.ColorRating.colorRatingLow'),
      middle: t('ProductDetail.RatingPopup.SizeRating.sizeRatingMiddle'),
      high: t('ProductDetail.RatingPopup.ColorRating.colorRatingHigh')
    },
    {
      type: 'Material',
      title: t('Category.Filter.material'),
      low: t('ProductDetail.RatingPopup.MaterialRating.materialRatingLow'),
      high: t('ProductDetail.RatingPopup.MaterialRating.materialRatingHigh')
    }
  ]
}
